import get from 'lodash/get'
import { default as slmlib } from 'slm'
import Prism from 'prismjs'

// Make sure that we are in manual mode
Prism.manual = true

export function lookupLanguage(lang) {
  const prismLanguage = Prism.languages[lang]

  if (!Prism.languages[lang]) {
    throw new Error(`Code highlighting language could not be found ${lang}`)
  } else {
    return prismLanguage
  }
}

export function highlight(str, lang) {
  // eslint-disable-next-line no-undef
  return Prism.highlight(str, lookupLanguage(lang))
}

function trimBlanks(arr) {
  const turn = (lines) => {
    const val = lines.reduce((acc, line) => {
      if (line !== '' || acc.length > 0) {
        acc.push(line)
      }
      return acc
    }, [])
    val.reverse()
    return val
  }

  return turn(turn(arr))
}

export function trimIndent(str) {
  const meta = str.split('\n').reduce(
    (acc, line) => {
      acc.lines.push(line)
      const indent = get(line.match(/[^\s]/), ['index'], null)

      if (acc.indent === null || (indent !== null && indent < acc.indent)) {
        acc.indent = indent
      }

      return acc
    },
    { indent: null, lines: [] }
  )

  return trimBlanks(
    meta.lines.map((l) => {
      return l.slice(meta.indent)
    })
  ).join('\n')
}

export function slm(str) {
  return slmlib.compile(str)()
}
